import { supportedLanguages } from '@lynx/client-core/src/components/LanguageDropdown/languagesList'
import { i18nextDefaultOptions } from '@lynx/client-core/src/services/translations'
import i18next from 'i18next'
import * as React from 'react'
import { initReactI18next } from 'react-i18next'
import { connect } from 'react-redux'
import { ApplicationState } from 'store'
import { ProfileState, setLang } from 'store/profile'
import { LanguageProps } from './interfaces'
class Language extends React.Component<LanguageProps> {
	componentDidMount(): void {
		this.initI18Next()
		this.setLanguageCode()
	}

	componentDidUpdate(oldProps: LanguageProps): void {
		if (!oldProps.profile.loggedIn && this.props.profile.loggedIn) {
			this.setLanguageCode()
		}
	}

	private initI18Next(): void {
		i18next.use(initReactI18next).init({
			...i18nextDefaultOptions,
			lng: this.props.profile.lang || 'en'
		})
	}

	private getBrowserLanguage(): string {
		const lang = this.props.profile.lang || navigator.language || 'en'

		if (lang.includes('-')) {
			return lang.split('-')[0]
		}

		return lang
	}

	private setLanguageCode = async (): Promise<void> => {
		let lang = this.getBrowserLanguage()

		if (!supportedLanguages.includes(lang)) {
			lang = 'en'
		}

		if (lang !== i18next.language) {
			i18next.changeLanguage(lang)
			this.props.setLang(lang) // Set Redux State
		}
	}

	render(): React.ReactNode {
		return null
	}
}

const mapStateToProps = (state: ApplicationState): { profile: ProfileState } => ({
	profile: state.profile
})

export default connect(mapStateToProps, { setLang })(Language)
